import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Drawer, Flex, Form, Input, notification, Spin } from "antd";
import { useCreateIpScaleMutation } from "api/sales-order/ip-scale-api";
import { useEffect } from "react";
import { IpScaleForm } from "../types";

interface IpScaleModalProps {
	open: boolean;
	onClose: () => void;
}

const IpScaleModal = ({ open, onClose }: IpScaleModalProps) => {
	const [form] = Form.useForm<IpScaleForm>();

	const [createIpScale, { isLoading }] = useCreateIpScaleMutation();

	useEffect(() => {
		if (!open) form.resetFields();
	}, [open, form]);

	const handleOnFinish = async (values: IpScaleForm) => {
		try {
			await createIpScale({ farmName: values.farmName.trim(), scaleIp: values.scaleIp.trim() }).unwrap();

			onClose();
			notification.success({ message: "Tạo mới IP cân thành công!" });
		} catch (error: any) {
			const message = error?.data?.message;
			notification.error({
				message: (Array.isArray(message) ? message.join(", ") : message) || "Có lỗi xảy ra.",
			});
		}
	};

	return (
		<Drawer
			title="Tạo mới IP cân"
			open={open}
			width={500}
			onClose={onClose}
			footer={
				<Flex gap={10} justify="flex-end">
					<Button disabled={isLoading} onClick={onClose} icon={<CloseOutlined />}>
						Huỷ bỏ
					</Button>
					<Button loading={isLoading} disabled={isLoading} type="primary" onClick={() => form.submit()} ghost icon={<SaveOutlined />}>
						Lưu
					</Button>
				</Flex>
			}>
			<Spin spinning={isLoading} tip="Đang tải...">
				<Form<IpScaleForm> form={form} layout="vertical" onFinish={handleOnFinish}>
					<Form.Item
						label="Tên trại"
						name="farmName"
						rules={[
							{ required: true, whitespace: true, message: "Nhập tên trại" },
							{ max: 255, message: "Tên trại tối đa 255 ký tự" },
						]}>
						<Input placeholder="Nhập tên trại" />
					</Form.Item>
					<Form.Item
						label="IP cân"
						name="scaleIp"
						rules={[
							{ required: true, whitespace: true, message: "Nhập IP cân" },
							{ max: 30, message: "IP cân tối đa 30 ký tự" },
						]}>
						<Input placeholder="VD: 192.168.1.10" />
					</Form.Item>
				</Form>
			</Spin>
		</Drawer>
	);
};

export default IpScaleModal;
